import { api_instances } from '../api/api-commons';
import { resetDataStore } from '../store/data/slice';
import { useAppDispatch } from '../store/hooks';

export function useSecurityToken(): [
  string | null,
  (value: string | null) => void
] {
  const dispatch = useAppDispatch();

  function setter(value: string | null) {
    sessionStorage.setItem('security_token', value || '');
    api_instances.forEach(
      (instance) =>
        (instance.defaults.headers['Authorization'] = `Bearer ${value}`)
    );

    dispatch(resetDataStore());
  }

  return [getSecurityToken(), setter];
}

export function getSecurityToken() {
  return sessionStorage.getItem('security_token');
}
